import { BusinessUnitQuotationQuestion, IBusinessUnitQuotationQuestionInfo } from "./business-unit/business-unit-quotation-question";
import { EntityBase, IEntityBaseInfo } from "../entity/entitybase";
import { IMultiStatusInfo, MultiStatus } from "../multi-status/multi-status";
import { IMultiStatusConfigInfo, MultiStatusConfig } from "../multi-status/multi-status-config";

export interface IQuotationQuestionInfo extends IEntityBaseInfo {

  Label?: string;
  Description?: string;
  IsAnswered?: boolean;
  BusinessUnitQuotationQuestions: IBusinessUnitQuotationQuestionInfo[]
}

export class QuotationQuestion extends EntityBase {

  Label?: string;
  Description?: string;
  IsAnswered?: boolean;

  // Client side properties
  AnsweredQuestionConfig?: MultiStatusConfig;
  QuestionHasBeenAnswered?: boolean;
  BusinessUnitQuotationQuestions: BusinessUnitQuotationQuestion[];

  constructor(info: IQuotationQuestionInfo) {
    super(info);

    this.Label = info.Label;
    this.Description = info.Description;
    this.IsAnswered = info.IsAnswered;
    this.AnsweredQuestionConfig = this.buildAnswerStatusConfig();
    this.BusinessUnitQuotationQuestions = info.BusinessUnitQuotationQuestions?.map(bqq => new BusinessUnitQuotationQuestion(bqq)) ?? [];

    this.QuestionHasBeenAnswered = false;
    if (this.ReadOnly) {
      this.setAnswerDisabledStyle();
    }
  }

  override title(): string {
    return `Question de devis : ${this.Label}`;
  }

  override description(): string {
    return `Description : ${this.Description}`;
  }

  changeAnswerStyle() {
    if (!this.AnsweredQuestionConfig) return;

    if (this.IsAnswered) {
      this.AnsweredQuestionConfig.Statuses[0].Style = "color: var(--dropdown-bg); background-color: var(--docarchive-month-label)";
      this.AnsweredQuestionConfig.Statuses[1].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
    } else {
      this.AnsweredQuestionConfig.Statuses[0].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
      this.AnsweredQuestionConfig.Statuses[1].Style = "color: var(--dropdown-bg); background-color: var(--docarchive-month-label)";
    }

    this.QuestionHasBeenAnswered = true;
  }

  setAnswerDisabledStyle() {
    if (!this.AnsweredQuestionConfig) return;

    if (this.IsAnswered) {
      this.AnsweredQuestionConfig.Statuses[0].Style = "color: #FFFFFF; background-color: var(--quote-question-answered--disabled)";
      this.AnsweredQuestionConfig.Statuses[1].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
    } else {
      this.AnsweredQuestionConfig.Statuses[0].Style = "color: var(--module-title); background-color: var(--dropdown-bg)";
      this.AnsweredQuestionConfig.Statuses[1].Style = "color: #FFFFFF; background-color: var(--quote-question-answered--disabled)";
    }

    this.QuestionHasBeenAnswered = true;
  }

  buildAnswerStatusConfig(): MultiStatusConfig {
    return new MultiStatusConfig(<IMultiStatusConfigInfo>{
      Statuses: [
        new MultiStatus(<IMultiStatusInfo>{
          Label: 'app.shared.yes',
          Style: 'color: var(--module-title); background-color: var(--quote-question-not-answered)',
          Handler: () => { this.IsAnswered = true; this.changeAnswerStyle() },
        }),
        new MultiStatus(<IMultiStatusInfo>{
          Label: 'app.shared.no',
          Style: 'color: var(--module-title); background-color: var(--quote-question-not-answered)',
          Handler: () => { this.IsAnswered = false; this.changeAnswerStyle() },
        })
      ]
    });
  }
}
